module.exports = __webpack_public_path__ + "static/img/1-4.181b33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-4.png
// module id = STNy
// module chunks = 1